import styled from 'styled-components'

export const StyledBiddingResultModal = styled.div`
  padding: 29px 25px;
`

export const BiddingResulHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const BiddingResulHeaderIcon = styled.div`
  color: rgba(25, 160, 45, 1);
`

export const BiddingResulHeaderPrice = styled.div`
  font-size: 40px;
  font-weight: 600;
  margin-top: 24px;
`

export const BiddingResulHeaderTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  margin-top: 22px;
`

export const BiddingResulHeaderDesc = styled.div`
  font-size: 16px;
  margin-top: 16px;
`

export const BiddingWarningArea = styled(BiddingResulHeader)`
  border-radius: 8px;
  background-color: rgba(255, 247, 236, 1);
  padding: 2rem;
  color: rgba(255, 181, 65, 1);
  margin-top: 2rem;

  b,
  p {
    color: #000;
    font-size: 16px;
    text-align: center;
    margin-top: 10px;
  }

  p {
    line-height: 24px;
  }

  button {
    margin-top: 15px;
  }
`
